<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">Проекты договора</h1>
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mb-40">
        <div class="page__row">
          <div class="page__item user-list__search page__search">
            <SearchForm :value="searchValue"
                        @form-submit="setSearchValue"
            />
          </div>
        </div>
        <div class="page__item">
          <div class="page__row">
            <transition name="fade" v-if="roleAccessRemove">
              <div class="page__item" v-if="isActiveDelete">
                <AppButtonSmRemove title="Удалить" @click.stop.native="showRemoveConfirmationGroup" />
              </div>
            </transition>
            <div class="page__item" v-if="roleAccessCreate">
              <AppButtonSmAdd title="Создать"
                              @click.native="showModal(null)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="page__row mb-20" v-if="projects.length !== 0">
        <AppTable :data="projects"
                  :headers="tableHeader"
                  :has-checkbox="roleAccessRemove"
                  :isMenuControlsActive=false
                  :all-items-active="tableHeader.allActive"
                  @toggle-active-item="toggleActiveItem"
                  @toggle-active-all="toggleActiveAll"
                  @edit-this-item="showModal"
                  @show-this-item="showModal"
                  @save-item-info="saveContractProjectItem"
                  @remove-this-item="showRemoveConfirmation"
        />
      </div>
      <div class="page__row mb-20"  v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="Записи не найдены"/>
        </div>
      </div>
    </section>

    <section class="section page__footer user-list__footer">
      <div class="page__row" v-if="pagination.lastPage > 1">
        <VPagination
          :pageList="pagination.pageList"
          :currentPage="pagination.currentPage"
          :lastPage="pagination.lastPage"
          @get-page="getPage"
        />
      </div>
    </section>

    <transition name="fade">
      <AppConfirmation v-if="removeConfirmation.active && roleAccessRemove"
                       :text="removeConfirmation.group ? 'Вы действительно хотите удалить эти проекты?' : 'Вы действительно хотите удалить этот проект?'"
                       @confirm="removeConfirmation.group ? deleteContractsProjectChecked() : removeProject()"
                       @reject="closeRemoveConfirmation"
      />
      <ContractProjectModal v-if="modal.active && roleAccessEdit"
                           :state="modal"
                           @set-item-name="setContractProjectItemName"
                           @set-item-color="setContractProjectItemColor"
                           @clear-validation="clearModalValidation"
                           @save-item-info="saveContractProjectItem"
                           @close-modal="closeModal"
      />
      <AppModal v-if="deleteResponseModal.isActive && !deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                :title="deleteResponseModal.title"
                :text="deleteResponseModal.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModal.type"
                @confirm="closeDeleteModal"
      />
      <AppModal v-if="deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                :title="deleteResponseModalWithTreaties.title"
                :text="deleteResponseModalWithTreaties.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModalWithTreaties.type"
                @confirm="closeDeleteModalWithTreaties"
      />
    </transition>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>

import SearchForm from '@/components/page/input/SearchForm'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import VPagination from '@/components/page/VPagination'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import ContractProjectModal from '@/components/contract/ContractProjectModal'
import AppModal from '@/components/page/modal/AppModal'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'

export default {
  name: 'ContractProject',
  components: {
    ThePagePreloader,
    AppConfirmation,
    VPagination,
    AppNoRecordsPlaceholder,
    AppTable,
    AppButtonSmAdd,
    SearchForm,
    ContractProjectModal,
    AppModal,
    AppButtonSmRemove
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null,
        group: false
      }
    }
  },
  computed: {
    modal () {
      return this.$store.getters['contractProjectListPage/getContractsProjectListModal']
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    tableHeader () {
      return this.$store.getters['contractProjectListPage/getContractsProjectListTableHeaders']
    },
    projects () {
      return this.$store.getters['contractProjectListPage/getContractsProjectList'].map(project => {
        return ({
          id: project.id,
          isActive: project.isActive,
          values: [
            project.name
          ]
        })
      })
    },
    searchValue () {
      return this.$store.getters['contractProjectListPage/getContractsProjectListSearchValue']
    },
    filter () {
      return this.$store.getters['contractProjectListPage/getContractsProjectListFilter']
    },
    pagination () {
      return this.$store.getters['contractProjectListPage/getContractsProjectListPagination']
    },
    isLoading () {
      return this.$store.getters['contractProjectListPage/getContractsProjectListIsLoading']
    },
    deleteResponseModal () {
      return this.$store.getters['contractProjectListPage/getContractsProjectListResponseModal']
    },
    deleteResponseModalWithTreaties () {
      return this.$store.getters['contractProjectListPage/getContractsProjectListResponseModalWithTreaties']
    },
    isActiveDelete () {
      return this.$store.getters['contractProjectListPage/getContractsProjectListActiveDelete']
    },
    roleAccessCreate () {
      return this.$store.getters.getRoleRightContracts.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContracts.actions.remove
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightContracts.actions.update
    }
  },
  methods: {
    toggleItemControls (itemId) {
      this.$store.dispatch('contractProjectListPage/toggleContractsProjectListItemControls', itemId)
    },
    toggleActiveItem (itemId) {
      this.$store.dispatch('contractProjectListPage/toggleContractsProjectListItemActive', itemId)
    },
    toggleActiveAll () {
      this.$store.dispatch('contractProjectListPage/toggleContractsProjectListItemActiveAll')
    },
    showModal (itemId) {
      this.$store.dispatch('contractProjectListPage/showContractsProjectModal', itemId)
    },
    setContractProjectItemName (value) {
      this.$store.dispatch('contractProjectListPage/setContractsProjectItemName', value)
    },
    setContractProjectItemColor (value) {
      this.$store.dispatch('contractProjectListPage/setContractsProjectItemColor', value)
    },
    clearModalValidation (inputName) {
      this.$store.dispatch('contractProjectListPage/clearContractsProjectModalValidation', inputName)
    },
    saveContractProjectItem (itemId) {
      this.$store.dispatch('contractProjectListPage/saveContractsProjectItem', itemId)
    },
    closeModal () {
      this.$store.dispatch('contractProjectListPage/closeContractsProjectModal')
    },
    showRemoveConfirmation (id) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = id
    },
    removeProject () {
      const itemId = this.removeConfirmation.id
      this.$store.dispatch('contractProjectListPage/removeContractsProject', itemId)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
      this.removeConfirmation.group = false
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },
    deleteContractsProjectChecked () {
      this.removeConfirmation.active = false
      this.$store.dispatch('contractProjectListPage/deleteContractsProjectListCheckedItems')
      this.removeConfirmation.group = false
    },
    closeDeleteModal () {
      this.$store.dispatch('contractProjectListPage/closeContractsProjectListDeleteModal')
    },
    closeDeleteModalWithTreaties () {
      this.$store.dispatch('contractProjectListPage/closeContractsProjectListDeleteModalWithTreaties')
    },

    // search
    setSearchValue (value) {
      this.$store.dispatch('contractProjectListPage/setContractsProjectListSearchValue', value)
    },

    // filter

    // pagination
    togglePageList () {
      this.$store.dispatch('contractProjectListPage/toggleContractsProjectListPageList')
    },
    previousPage () {
      this.$store.dispatch('contractProjectListPage/getContractsProjectListPrevPage')
    },
    nextPage () {
      this.$store.dispatch('contractProjectListPage/getContractsProjectListNextPage')
    },
    getPage (pageNum) {
      this.$store.dispatch('contractProjectListPage/getContractsProjectListPage', pageNum)
    }
  },
  mounted () {
    this.$store.dispatch('contractProjectListPage/getContractsProject')
  },
  destroyed () {
    this.$store.commit('contractProjectListPage/RESET_CONTRACTS_PROJECT_LIST_STORE')
  }
}
</script>

<style lang="scss" scoped>
.no-records {
  margin-top: 80px;
  align-items: center;
  width: 100%;
  display: flex;
}
</style>
